export default __webpack_public_path__ + "static/media/information--truck-trailer-lane-right--g1.78d4967c.png";